import { Outlet } from 'react-router-dom';

const CostCentersOutlet = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default CostCentersOutlet;
